import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import settings from '../../settings/index'
import router from '../router'

Vue.use(VueAxios, axios)

const regs = []
if (settings.isProxy) {
  Object.keys(settings.apiUrls).forEach((key) => {
    let reg = new RegExp(key)
    regs.push({reg, value: settings.apiUrls[key]})
  })
}

Vue.axios.interceptors.request.use((config) => {
  // 前端proxy
  let url = config.url
  for (let i = 0; i < regs.length; i++) {
    let item = regs[i]
    if (item.reg.test(url)) {
      config.url = url.replace(item.reg, item.value)
      break
    }
  }
  // 解决get请求缓存问题
  if (config.method && config.method.toLowerCase() === 'get') {
    config.url = config.url + '?t_t=' + new Date().getTime()
  }
  config.headers.token = window.sessionStorage.getItem('apptoken')
  return config
}, (err) => {
  console.log(err)
  return Promise.reject(err)
})

Vue.axios.interceptors.response.use((res) => {
  if (res && res.status === 200) {
    res = res.data
    if (res && res.code === 301) {
      window.sessionStorage.removeItem('apptoken')
      router.replace('/login')
    }
  }
  return res
}, (err) => {
  console.log(err)
  return Promise.reject(err)
})



// WEBPACK FOOTER //
// ./src/axios/index.js